export class GeoUtils {
  private static watchPositionId: number;
  public static openMapsApp(lat: number, lng: number) {
    if ((navigator.platform.indexOf("iPhone") != -1) ||
      (navigator.platform.indexOf("iPad") != -1) ||
      (navigator.platform.indexOf("iPod") != -1)) {
      window.open(`maps://maps.google.com/maps?daddr=${lat},${lng}&amp;ll=`);
    } else {
      /* else use Google */
      window.open(`https://maps.google.com/maps?daddr=${lat},${lng}&amp;ll=`);
    }
  }
  public static watchLocation(res: PositionCallback, err: PositionErrorCallback) {
    this.watchPositionId = navigator.geolocation.watchPosition(res, err);
  }

  public static endWatchLocation() {
    navigator.geolocation.clearWatch(this.watchPositionId);
  }

}
